module.exports = __webpack_public_path__ + "img/35.4a73284c.webp";